const parentFolder = 'animation/'
const lottieJsonAnimation = {
  v: '5.9.0',
  fr: 23.9759979248047,
  ip: 0,
  op: 305.999973514775,
  w: 560,
  h: 556,
  nm: 'KV',
  ddd: 0,
  assets: [
    { id: 'image_0', w: 265, h: 265, u: parentFolder, p: 'img_0.png', e: 0 },
    { id: 'image_1', w: 279, h: 282, u: parentFolder, p: 'img_1.png', e: 0 },
    { id: 'image_2', w: 279, h: 283, u: parentFolder, p: 'img_2.png', e: 0 },
    { id: 'image_3', w: 279, h: 287, u: parentFolder, p: 'img_3.png', e: 0 },
    { id: 'image_4', w: 56, h: 56, u: parentFolder, p: 'img_4.png', e: 0 },
    { id: 'image_5', w: 55, h: 55, u: parentFolder, p: 'img_5.png', e: 0 },
    { id: 'image_6', w: 54, h: 54, u: parentFolder, p: 'img_6.png', e: 0 },
  ],
  layers: [
    {
      ddd: 0,
      ind: 1,
      ty: 2,
      nm: 'planeta-1.png',
      cl: 'png',
      refId: 'image_0',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [277, 281, 0], ix: 2, l: 2 },
        a: { a: 0, k: [132.5, 132.5, 0], ix: 1, l: 2 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.357, 0.357, 0.667], y: [1, 1, 1] },
              o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
              t: 258,
              s: [0, 0, 100],
            },
            {
              i: { x: [0.402, 0.402, 0.667], y: [1, 1, 1] },
              o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
              t: 271.34,
              s: [110, 110, 100],
            },
            { t: 284.999975332388, s: [105.038, 105.038, 100] },
          ],
          ix: 6,
          l: 2,
        },
      },
      ao: 0,
      ip: 0,
      op: 311.999972995456,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 2,
      ty: 2,
      nm: 'planeta-3.png',
      cl: 'png',
      refId: 'image_1',
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            {
              i: { x: [0.833], y: [0.833] },
              o: { x: [0.167], y: [0.167] },
              t: 274,
              s: [100],
            },
            { t: 279.999975765153, s: [0] },
          ],
          ix: 11,
        },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [276, 284, 0], ix: 2, l: 2 },
        a: { a: 0, k: [139.5, 141, 0], ix: 1, l: 2 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.357, 0.357, 0.667], y: [1, 1, 1] },
              o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
              t: 192,
              s: [0, 0, 100],
            },
            {
              i: { x: [0.402, 0.402, 0.667], y: [1, 1, 1] },
              o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
              t: 205.34,
              s: [110, 110, 100],
            },
            { t: 218.999981044888, s: [100, 100, 100] },
          ],
          ix: 6,
          l: 2,
        },
      },
      ao: 0,
      ip: 0,
      op: 311.999972995456,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 3,
      ty: 2,
      nm: 'planeta-2.png',
      cl: 'png',
      refId: 'image_2',
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            {
              i: { x: [0.833], y: [0.833] },
              o: { x: [0.167], y: [0.167] },
              t: 207,
              s: [100],
            },
            { t: 212.999981564206, s: [0] },
          ],
          ix: 11,
        },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [278, 283, 0], ix: 2, l: 2 },
        a: { a: 0, k: [139.5, 141.5, 0], ix: 1, l: 2 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.357, 0.357, 0.667], y: [1, 1, 1] },
              o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
              t: 128,
              s: [0, 0, 100],
            },
            {
              i: { x: [0.402, 0.402, 0.667], y: [1, 1, 1] },
              o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
              t: 141.34,
              s: [110, 110, 100],
            },
            { t: 154.999986584281, s: [99, 99, 100] },
          ],
          ix: 6,
          l: 2,
        },
      },
      ao: 0,
      ip: 0,
      op: 311.999972995456,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 4,
      ty: 2,
      nm: 'planeta-4.png',
      cl: 'png',
      refId: 'image_3',
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            {
              i: { x: [0.833], y: [0.833] },
              o: { x: [0.167], y: [0.167] },
              t: 141,
              s: [100],
            },
            { t: 146.999987276705, s: [0] },
          ],
          ix: 11,
        },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [278, 285, 0], ix: 2, l: 2 },
        a: { a: 0, k: [139.5, 143.5, 0], ix: 1, l: 2 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.357, 0.357, 0.667], y: [1, 1, 1] },
              o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
              t: 73.66,
              s: [0, 0, 100],
            },
            {
              i: { x: [0.402, 0.402, 0.667], y: [1, 1, 1] },
              o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
              t: 87,
              s: [110, 110, 100],
            },
            { t: 100.999991258145, s: [100, 100, 100] },
          ],
          ix: 6,
          l: 2,
        },
      },
      ao: 0,
      ip: 0,
      op: 311.999972995456,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 5,
      ty: 2,
      nm: 'planeta-1.png',
      cl: 'png',
      refId: 'image_0',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [277, 281, 0], ix: 2, l: 2 },
        a: { a: 0, k: [132.5, 132.5, 0], ix: 1, l: 2 },
        s: { a: 0, k: [104.528, 104.528, 100], ix: 6, l: 2 },
      },
      ao: 0,
      ip: 0,
      op: 311.999972995456,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 6,
      ty: 2,
      nm: 'planetita-1.png',
      cl: 'png',
      refId: 'image_4',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [106, 253, 0], ix: 2, l: 2 },
        a: { a: 0, k: [28, 28, 0], ix: 1, l: 2 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
              o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
              t: 23,
              s: [0, 0, 100],
            },
            { t: 31.9999972303032, s: [100, 100, 100] },
          ],
          ix: 6,
          l: 2,
        },
      },
      ao: 0,
      ip: 0,
      op: 311.999972995456,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 7,
      ty: 2,
      nm: 'planetita-2.png',
      cl: 'png',
      refId: 'image_5',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [321, 77, 0], ix: 2, l: 2 },
        a: { a: 0, k: [27.5, 27.5, 0], ix: 1, l: 2 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
              o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
              t: 32,
              s: [0, 0, 100],
            },
            { t: 40.999996451326, s: [100, 100, 100] },
          ],
          ix: 6,
          l: 2,
        },
      },
      ao: 0,
      ip: 0,
      op: 311.999972995456,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 8,
      ty: 2,
      nm: 'planetita-3.png',
      cl: 'png',
      refId: 'image_6',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [512, 364, 0], ix: 2, l: 2 },
        a: { a: 0, k: [27, 27, 0], ix: 1, l: 2 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
              o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
              t: 43,
              s: [0, 0, 100],
            },
            { t: 51.9999954992427, s: [100, 100, 100] },
          ],
          ix: 6,
          l: 2,
        },
      },
      ao: 0,
      ip: 0,
      op: 311.999972995456,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 10,
      ty: 4,
      nm: 'Capa de formas 3',
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            {
              i: { x: [0.833], y: [0.833] },
              o: { x: [0.167], y: [0.167] },
              t: 24,
              s: [0],
            },
            {
              i: { x: [0.833], y: [0.833] },
              o: { x: [0.167], y: [0.167] },
              t: 27,
              s: [100],
            },
            { t: 54.9999952395837, s: [100] },
          ],
          ix: 11,
        },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [276, 272, 0], ix: 2, l: 2 },
        a: { a: 0, k: [490, 128, 0], ix: 1, l: 2 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.173, 0.173, 0.667], y: [1, 1, 1] },
              o: { x: [0.695, 0.695, 0.333], y: [0, 0, 0] },
              t: 24,
              s: [0, 0, 100],
            },
            { t: 48.9999957589018, s: [200, 200, 100] },
          ],
          ix: 6,
          l: 2,
        },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              d: 1,
              ty: 'el',
              s: { a: 0, k: [246.883, 246.883], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              nm: 'Trazado elíptico 1',
              mn: 'ADBE Vector Shape - Ellipse',
              hd: false,
            },
            {
              ty: 'st',
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0.25, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: 'Trazo 1',
              mn: 'ADBE Vector Graphic - Stroke',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [490.441, 131.441], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: 'Transformar',
            },
          ],
          nm: 'Elipse 1',
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false,
        },
      ],
      ip: 0,
      op: 311.999972995456,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 11,
      ty: 4,
      nm: 'Capa de formas 2',
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            {
              i: { x: [0.833], y: [0.833] },
              o: { x: [0.167], y: [0.167] },
              t: 12,
              s: [0],
            },
            {
              i: { x: [0.833], y: [0.833] },
              o: { x: [0.167], y: [0.167] },
              t: 16,
              s: [100],
            },
            { t: 54.9999952395837, s: [100] },
          ],
          ix: 11,
        },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [276, 272, 0], ix: 2, l: 2 },
        a: { a: 0, k: [490, 128, 0], ix: 1, l: 2 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.296, 0.296, 0.667], y: [1.001, 1.001, 1] },
              o: { x: [0.632, 0.632, 0.333], y: [-0.001, -0.001, 0] },
              t: 12,
              s: [0, 0, 100],
            },
            { t: 36.9999967975381, s: [170.833, 170.833, 100] },
          ],
          ix: 6,
          l: 2,
        },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              d: 1,
              ty: 'el',
              s: { a: 0, k: [246.883, 246.883], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              nm: 'Trazado elíptico 1',
              mn: 'ADBE Vector Shape - Ellipse',
              hd: false,
            },
            {
              ty: 'st',
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0.5, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: 'Trazo 1',
              mn: 'ADBE Vector Graphic - Stroke',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [490.441, 131.441], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: 'Transformar',
            },
          ],
          nm: 'Elipse 1',
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false,
        },
      ],
      ip: 0,
      op: 311.999972995456,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 12,
      ty: 4,
      nm: 'Capa de formas 1',
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            {
              i: { x: [0.833], y: [0.833] },
              o: { x: [0.167], y: [0.167] },
              t: 0,
              s: [0],
            },
            {
              i: { x: [0.833], y: [0.833] },
              o: { x: [0.167], y: [0.167] },
              t: 7,
              s: [100],
            },
            { t: 54.9999952395837, s: [100] },
          ],
          ix: 11,
        },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [275, 273, 0], ix: 2, l: 2 },
        a: { a: 0, k: [490, 128, 0], ix: 1, l: 2 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.265, 0.265, 0.667], y: [1, 1, 1] },
              o: { x: [0.691, 0.691, 0.333], y: [0, 0, 0] },
              t: 0,
              s: [0, 0, 100],
            },
            { t: 23.9999979227274, s: [140.833, 140.833, 100] },
          ],
          ix: 6,
          l: 2,
        },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              d: 1,
              ty: 'el',
              s: { a: 0, k: [246.883, 246.883], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              nm: 'Trazado elíptico 1',
              mn: 'ADBE Vector Shape - Ellipse',
              hd: false,
            },
            {
              ty: 'st',
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 0.75, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: 'Trazo 1',
              mn: 'ADBE Vector Graphic - Stroke',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [490.441, 131.441], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: 'Transformar',
            },
          ],
          nm: 'Elipse 1',
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false,
        },
      ],
      ip: 0,
      op: 311.999972995456,
      st: 0,
      bm: 0,
    },
  ],
  markers: [],
}
export default lottieJsonAnimation
